module.exports = __webpack_public_path__ + "img/Elbit.aec37656.svg";